export const IS_DEV_ORG = typeof window !== 'undefined' && window.location.hostname === 'dev.my.pitcher.com'
export const IS_LOCALHOST = typeof window !== 'undefined' && window.location.hostname === 'localhost'
